// extracted by mini-css-extract-plugin
export default {"ticketContainer":"styles_ticketContainer__gOzx2","ticket":"styles_ticket__8gFcp"};